import { getComponentCssUrl, getGlobalCssUrl } from '../Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createNotificationBannerTemplate() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl('NotificationBanner--wc.css')}" rel="stylesheet" />
`
  return t;
}

const getTemplateNotificationBannerStyles = () => createNotificationBannerTemplate();
export { getTemplateNotificationBannerStyles };